import { Subject } from 'rxjs';
import { SessionTimerStatus } from '../objects/Session';
import * as i0 from "@angular/core";
var SessionTimerService = /** @class */ (function () {
    function SessionTimerService() {
        this.sessionTimerStatus = new Subject();
        this.sessionTimerChanged$ = this.sessionTimerStatus.asObservable();
        this.keepSessionAlive = new Subject();
        this.keepSessionAliveChanged$ = this.keepSessionAlive.asObservable();
    }
    SessionTimerService.prototype.startSessionTimer = function () {
        this.sessionTimerStatus.next(SessionTimerStatus.START);
    };
    SessionTimerService.prototype.resetSessionTimer = function () {
        this.sessionTimerStatus.next(SessionTimerStatus.RESET);
    };
    SessionTimerService.prototype.stopSessionTimer = function () {
        this.sessionTimerStatus.next(SessionTimerStatus.STOP);
    };
    SessionTimerService.prototype.setKeepSessionAlive = function (keepAlive) {
        this.keepSessionAlive.next(keepAlive);
    };
    SessionTimerService.ngInjectableDef = i0.defineInjectable({ factory: function SessionTimerService_Factory() { return new SessionTimerService(); }, token: SessionTimerService, providedIn: "root" });
    return SessionTimerService;
}());
export { SessionTimerService };
